var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEvVehicle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1016 5.50391V2.50391H34.6016V5.50391H33.3516C33.0285 5.49861 32.7076 5.55701 32.4071 5.67577C32.1066 5.79453 31.8324 5.97132 31.6003 6.19604C31.3681 6.42077 31.1825 6.68903 31.054 6.9855C30.9256 7.28197 30.8568 7.60084 30.8516 7.92391V23.0819C30.8565 23.4051 30.9251 23.7242 31.0535 24.0209C31.1818 24.3176 31.3674 24.5861 31.5996 24.8111C31.8318 25.036 32.106 25.213 32.4066 25.3319C32.7072 25.4507 33.0283 25.5092 33.3516 25.5039H43.3516C44.0042 25.5141 44.6342 25.2646 45.103 24.8105C45.5718 24.3563 45.841 23.7345 45.8516 23.0819V7.92391C45.8405 7.27162 45.571 6.65038 45.1023 6.19664C44.6335 5.74289 44.0039 5.49374 43.3516 5.50391H42.1016Z",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0436 9.50391L36.2656 14.5039H40.4316L37.6556 19.5039",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.938 27.4961H7.5L3.622 31.3761C2.26376 32.7339 1.50046 34.5756 1.5 36.4961C1.5 37.2917 1.81607 38.0548 2.37868 38.6174C2.94129 39.18 3.70435 39.4961 4.5 39.4961H43.5C44.2956 39.4961 45.0587 39.18 45.6213 38.6174C46.1839 38.0548 46.5 37.2917 46.5 36.4961C46.4995 34.5756 45.7362 32.7339 44.378 31.3761",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14844 33.4961H10.4984",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.85 33.4961H37.5",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 27.4961L10.9 18.4161C11.2213 17.5584 11.7968 16.8193 12.5494 16.2975C13.3021 15.7757 14.1961 15.4961 15.112 15.4961H24.932",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 39.4961V42.4961C4.62807 43.3998 5.10274 44.2182 5.82354 44.7781C6.54434 45.338 7.45471 45.5955 8.362 45.4961C9.26938 45.596 10.18 45.3387 10.9009 44.7787C11.6219 44.2187 12.0964 43.4 12.224 42.4961V39.4961H4.5Z",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7773 39.4961V42.4961C35.9049 43.4 36.3795 44.2187 37.1004 44.7787C37.8213 45.3387 38.732 45.596 39.6393 45.4961C40.5466 45.5955 41.457 45.338 42.1778 44.7781C42.8986 44.2182 43.3733 43.3998 43.5013 42.4961V39.4961H35.7773Z",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvVehicle);
export default __webpack_public_path__ + "static/media/icon-ev-vehicle.2da254b9a49a3acf2bcf94cce0062141.svg";
export { ForwardRef as ReactComponent };